import store from '@/store'
import api from '@/fetch/api'
import {
  Toast,
  //Dialog
} from 'vant';

const appid = 'wxa3d922a095c1eca2';//zs hq

// function syncToken() {
//   console.log('syncToken');
//   // if (process.env.NODE_ENV == 'development') {
//   //     var storage = process.env.DEV_API_TOKEN;
//   // }else{
//   //     var storage = localStorage['token_info_'+userid];
//   // }
//   var storage = sessionStorage['site_current_token'];
//
//   if (!storage) {
//     return false;
//   }
//
//   //将缓存中的token信息 ，加入store
//   // var current_token_info = storage;
//   // if (current_token_info) {
//   //   //this.$store.commit('set_appid', current_token_info.app_id ? current_token_info.app_id : '');
//   //   store.commit('set_token', current_token_info ? current_token_info : '');
//   //   return current_token_info ? current_token_info : '';
//   // } else {
//   //   return false;
//   // }
//
// }

function goLogin(next_to) {
  var scope = 'snsapi_userinfo';
  var url = 'http://hqyy.tzpdg.top';//zs
  var auth_url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(url + next_to) + '&response_type=code&scope=' + scope + '&state=STATE#wechat_redirect';
  window.location.replace(auth_url);
}


// function getToken(code, suc_func) {
//   api.getServiceToken().then(function(resData) {
//     var res = JSON.parse(resData);
//     setToken(res);
//     suc_func = suc_func ? suc_func : function() {};
//     suc_func();
//     console.log('getToken', res);
//   }).catch(function(err) {
//     console.log('getToken', err);
//   });
// }
//
//
// function setToken(token_info) {
//   sessionStorage['site_current_token'] = token_info;//JSON.stringify(token_info);
// }

function getUser(openid, suc_func) {
  api.getUserInfoByopenid(openid).then(function(resData) {
    var res = JSON.parse(resData);
    if (res.respCode == 0) {
      var UserInfo = res.data;
      if (UserInfo.openid) {
        var userid = UserInfo.id ? UserInfo.id : "";
        var phone = UserInfo.phone ? UserInfo.phone : "";
        var name = UserInfo.name ? UserInfo.name : "";
        store.commit('set_userid', userid)
        store.commit('set_mobile', phone)
        store.commit('set_username', name)
        suc_func = suc_func ? suc_func : function() {};
        suc_func();
      }
      else
      {
        store.commit('set_userid', '')
        store.commit('set_mobile', '')
        store.commit('set_username', '')
        suc_func = suc_func ? suc_func : function() {};
        suc_func();
      }
    }
    else
    {
      Toast.fail(res.message);
    }

  }).catch(function(err) {
    console.log('getUserInfo', err);
  });
}

function getUserInfo(code, suc_func) {
  api.getUserInfo(code).then(function(resData) {
    var res = JSON.parse(resData);
    if (res.respCode == 0) {
      var UserInfo = res.data;
      var userid = UserInfo.id ? UserInfo.id : "";
      var headimgurl = UserInfo.headimgurl ? UserInfo.headimgurl : "";
      var openid = UserInfo.openid ? UserInfo.openid : "";
      store.commit('set_userid', userid)
      store.commit('set_openid', openid);
      store.commit('set_headimgurl', headimgurl);

      if (UserInfo.sfky == 'Y') {
        var phone = UserInfo.phone ? UserInfo.phone : "";
        var name = UserInfo.name ? UserInfo.name : "";
        store.commit('set_mobile', phone);
        store.commit('set_username', name);
      }

      suc_func = suc_func ? suc_func : function() {};
      suc_func();
    }
    else {
      Toast.fail(res.message);
    }
  }).catch(function(err) {
    console.log('getUserInfo', err);
  });
}

function getBindVehicleState(openid) {
  console.log('openid', openid);
  // api.getBindVehicleState(openid).then(function(resData) {
  //   var res = JSON.parse(resData);
  //   if (res.respCode == 0) {
  //     localStorage.vehicleState = res.data;
  //     store.commit('set_vehicleState', res.data);
  //   }
  //   else {
  //     Toast.fail(res.message);
  //   }
  // }).catch(function(err) {
  //   console.log('getBindVehicleState', err);
  // });
}

export {
  //syncToken,
  goLogin,
  //getToken,
  //setToken,
  getUserInfo,
  getUser,
  getBindVehicleState

}
